import { render, staticRenderFns } from "./shopCheckPayment.vue?vue&type=template&id=9ddf1120"
import script from "./shopCheckPayment.vue?vue&type=script&lang=js"
export * from "./shopCheckPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports